import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import EditIcon from '@material-ui/icons/Edit';
import SearchIcon from '@material-ui/icons/Search';

import { toast } from 'react-toastify';
import {
  BottomCalendario,
  BottomMuralAvisos,
  BottomRoot,
  CardsRoot,
  DashboardDrawer,
  EventosCalendario,
  EventosCalendarioRolagem,
  FacilitadoresButton,
  FacilitadoresRoot,
  HeaderDashboardDrawer,
  InputNumeroProcesso,
  MuralCards,
  MuralCardsRoot,
  MuralRoot,
  MyInfoText,
  Root,
} from './Dashboard.style';
import { initializePageAction } from '../../store/theme.actions';
import { moveScroll } from '../../helpers/utils/utils';
import DashboardInfoCard from './Cards/DashboardInfoCards';
import { DashboardCalendario } from '../../components/DashboardCalendario/DashboardCalendario';
import {
  buscarInformacoesDashboardService,
  buscarInformacoesMuralService,
} from '../../services/core/dashboard/dashboard.services';
import LoadingUI from '../../components/UI/Loading/LoadingUI';
import DashboardMural from './Mural/DashboardMural';
import { DateUtils, hasUserPermissions } from '../../helpers';
import { DashboardController } from '../../controller';
import {
  RightDrawer, PublicarEventoCalendarioDashboard, AtualizarMuralDashboard, IconButtonTooltip,
} from '../../components';
import { SearchButton } from '../../components/SearchButton/SeachButton';
import { pesquisaProcessoController as controller } from '../../controller/pesquisarProcessos.controller';
import { KEY_NUMBER, changeKeyHandler } from '../../helpers/utils/changeEvents.utils';
import NumberInput from '../../components/UI/Field/Number/NumberInput';
import { DASHBOARD_ACOES } from '../../helpers/constants/dashboard.constants';

const drawerContextTypes = {
  calendario: 'calendario',
  mural: 'mural',

  isCalendario(value) {
    return value === this.calendario;
  },

  isMural(value) {
    return value === this.mural;
  },
};


function DashboardPage() {
  const dispatch = useDispatch();
  const history = useHistory();

  dispatch(initializePageAction('Home'));

  const [openSide, setOpenSide] = useState(false);
  const [activeContext, setActiveContext] = useState('');
  const [cardsInfos, setCardsInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [informacoesMural, setInformacoesMural] = useState(null);
  const [nroProcesso, setNroProcesso] = useState(null);

  const [selectedDate, setSelectedDate] = useState({
    date: DateUtils.getDateWithoutTime(),
    fullDate: DateUtils.getFullDateFromText(),
  });

  const [eventosCalendario, serEventosCalendario] = useState(DashboardController.makeDashboardCalendarEvents());

  const onClickEditarPaineis = (active) => {
    setOpenSide(old => !old);
    setActiveContext(active);
  };


  async function openNewProcesso() {
    const result = await controller.buscarIdsProcessos();
    const nroProcessoInt = nroProcesso.replace('.', '');
    const nroProcessoString = nroProcessoInt.toString();
    if (nroProcessoInt !== null && Object.prototype.hasOwnProperty.call(result, nroProcessoString)) {
      sessionStorage.setItem('nroProcesso', nroProcessoInt);
      localStorage.setItem('previousUrl', '/');
      history.push(`/processos/inspecao?nroProcesso=${nroProcessoInt}`);
    } else {
      toast.warning('Nenhum resultado foi encontrado relacionado à sua pesquisa.',
        { style: { width: '392px' } });
    }
  }

  const buscarInformacoesInicias = useCallback(async () => {
    try {
      setLoading(true);
      const response = await buscarInformacoesDashboardService();
      const muralResponse = await buscarInformacoesMuralService();
      setCardsInfo(response.data);
      setInformacoesMural(muralResponse.data);
    } catch (e) {
      // Nenhum tratamento...
    } finally {
      setLoading(false);
    }
  }, []);

  const updateDashboardCalendar = useCallback(async () => {
    const events = await DashboardController.findAllDashboardCalendarEventByDate(selectedDate.date);
    serEventosCalendario(events);
  }, [selectedDate.date]);

  const permission = React.useMemo(() => {
    const dashboardGerenciar = hasUserPermissions(1401);
    const ccClienteConsultar = hasUserPermissions(1801);
    const ccClienteConsultarTodos = hasUserPermissions(1802);
    const ccClienteEfetuarLancamentos = hasUserPermissions(1803);
    const ccClientePrestarContas = hasUserPermissions(1804);
    const hasAnyPermissionCCCliente = ccClienteConsultar
      || ccClienteConsultarTodos
      || ccClienteEfetuarLancamentos
      || ccClientePrestarContas;
    return {
      dashboardGerenciar,
      ccClienteConsultar,
      ccClienteConsultarTodos,
      ccClienteEfetuarLancamentos,
      ccClientePrestarContas,
      hasAnyPermissionCCCliente,
    };
  }, []);

  const onChange = (e) => {
    changeKeyHandler(e, KEY_NUMBER);
    setNroProcesso(e.target.value);
  };

  // Busca informações iniciais da tela.
  useEffect(() => {
    moveScroll();
    buscarInformacoesInicias().then();
  }, [buscarInformacoesInicias]);

  useEffect(() => {
    updateDashboardCalendar().then();
  }, [updateDashboardCalendar]);

  function handleCloseSideDrawer() {
    setActiveContext('');
    setOpenSide(!openSide);
  }

  function handleClickMuralCards(acao) {
    history.push(`/processos?acao=${acao}`);
  }
  return (
    <>
      <Root>
        <LoadingUI show={loading} />
        <CardsRoot>
          <DashboardInfoCard type="borderos" />
          <DashboardInfoCard type="clientes" />
          <DashboardInfoCard type="acordos" />
          <DashboardInfoCard type="processos" />
        </CardsRoot>
        <MuralRoot>
          <FacilitadoresRoot>
            <FacilitadoresButton onClick={() => history.push('/processos')}>
              Processos
            </FacilitadoresButton>
            <FacilitadoresButton onClick={() => history.push('/cliente')}>
              Clientes
            </FacilitadoresButton>
            <FacilitadoresButton
              onClick={() => history.push('/conta-corrente-cliente')}
              disabled={!permission.hasAnyPermissionCCCliente}
            >
              C/C de Cliente
            </FacilitadoresButton>
            <InputNumeroProcesso>
              <NumberInput
                numberType="integer"
                maxValue={999999999}
                name="numeroProcesso"
                label="Nº Processo"
                value={nroProcesso || ''}
                acceptEmptyValue
                onChange={onChange}
                fullWidth
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    openNewProcesso();
                  }
                }}
              />
              <SearchButton onClick={openNewProcesso} style={{ marginTop: '5px' }}>
                <SearchIcon style={{ marginLeft: 2 }} />
              </SearchButton>
            </InputNumeroProcesso>
          </FacilitadoresRoot>
          <MyInfoText>
            Minhas Informações
          </MyInfoText>
          <MuralCardsRoot>
            <MuralCards onClick={() => handleClickMuralCards(DASHBOARD_ACOES.MEUS_PROCESSOS)} style={{ cursor: 'pointer' }}>
              <div>{cardsInfos?.meusProcessos ?? 0}</div>
              <span>Meus Processos</span>
            </MuralCards>
            <MuralCards onClick={() => handleClickMuralCards(DASHBOARD_ACOES.PROCESSOS_NOVOS)} style={{ cursor: 'pointer' }}>
              <div>{cardsInfos?.processosNovos ?? 0}</div>
              <span>Processos Não Trabalhados</span>
            </MuralCards>
            <MuralCards onClick={() => handleClickMuralCards(DASHBOARD_ACOES.PROMESSAS_BOLETOS)} style={{ cursor: 'pointer' }}>
              <div>{cardsInfos?.promessasBoletos ?? 0}</div>
              <span>Promessas de Boletos</span>
            </MuralCards>
            <MuralCards onClick={() => handleClickMuralCards(DASHBOARD_ACOES.ACORDOS_NAO_CUMPRIDOS)} style={{ cursor: 'pointer' }}>
              <div>{cardsInfos?.acordosNaoCumpridos ?? 0}</div>
              <span>Acordos Não Cumpridos</span>
            </MuralCards>
            <MuralCards onClick={() => handleClickMuralCards(DASHBOARD_ACOES.PRAZOS)} style={{ cursor: 'pointer' }}>
              <div>{cardsInfos?.prazos ?? 0}</div>
              <span>Prazos</span>
            </MuralCards>
            <MuralCards onClick={() => handleClickMuralCards(DASHBOARD_ACOES.PROMESSAS_RETORNO)} style={{ cursor: 'pointer' }}>
              <div>{cardsInfos?.promessasRetorno ?? 0}</div>
              <span>Promessas de Retorno</span>
            </MuralCards>
          </MuralCardsRoot>
          <BottomRoot>
            <BottomCalendario>
              <span>Calendário</span>
              <IconButtonTooltip
                hint="Editar"
                type="edit"
                onClick={() => onClickEditarPaineis(drawerContextTypes.calendario)}
                disabled={!permission.dashboardGerenciar}
              >
                <EditIcon />
              </IconButtonTooltip>
              <div style={{ display: 'flex' }}>
                <DashboardCalendario date={selectedDate.date} handleChangeDate={setSelectedDate} />
                <EventosCalendario>
                  <div>{selectedDate.fullDate}</div>
                  <EventosCalendarioRolagem>
                    {eventosCalendario.map(event => (
                      <p key={event.key}>
                        <i className={event.icone} />
                        {event.descricao}
                      </p>
                    ))}
                  </EventosCalendarioRolagem>
                </EventosCalendario>
              </div>
            </BottomCalendario>
            <BottomMuralAvisos>
              <span>Mural de Avisos</span>
              <IconButtonTooltip
                hint="Editar"
                type="edit"
                onClick={() => onClickEditarPaineis(drawerContextTypes.mural)}
                disabled={!permission.dashboardGerenciar}
              />
              <DashboardMural informacoesMural={informacoesMural} />
            </BottomMuralAvisos>
          </BottomRoot>
        </MuralRoot>
      </Root>

      <RightDrawer open={openSide} handleCloseDrawer={handleCloseSideDrawer}>
        <DashboardDrawer>
          <HeaderDashboardDrawer>
            <p data-active={drawerContextTypes.isCalendario(activeContext)}>
              Calendário
            </p>
            <p data-active={drawerContextTypes.isMural(activeContext)}>
              Mural de Avisos
            </p>
          </HeaderDashboardDrawer>
          {drawerContextTypes.isCalendario(activeContext) && (
            <PublicarEventoCalendarioDashboard
              dashboardDate={selectedDate.date}
              handleCloseSideDrawer={handleCloseSideDrawer}
              handleLoading={setLoading}
              updateDashboardCalendar={updateDashboardCalendar}
            />
          )}

          {drawerContextTypes.isMural(activeContext) && (
            <AtualizarMuralDashboard
              setLoading={setLoading}
              setInformacoesMural={setInformacoesMural}
              handleCloseSideDrawer={handleCloseSideDrawer}
            />
          )}
        </DashboardDrawer>
      </RightDrawer>
    </>
  );
}

export default DashboardPage;
